<div class="message-input">
  <!-- Pending attachment preview -->
  <div *ngIf="pendingAttachment" class="mi-attachment-preview">
    <i class="pi pi-file"></i>
    <span>{{ pendingAttachment.name }}</span>
    <button (click)="removePendingAttachment()" title="Remove"><i class="pi pi-times"></i></button>
  </div>

  <!-- @mention suggestions -->
  <div *ngIf="mentionSuggestions.length > 0" class="mi-mentions">
    <div *ngFor="let m of mentionSuggestions" class="mi-mention-item" (click)="selectMention(m)">
      <span class="mi-mention-avatar">{{ m.user_name.charAt(0).toUpperCase() }}</span>
      <span>{{ m.user_name }}</span>
    </div>
  </div>

  <!-- Input row -->
  <div class="mi-input-row">
    <button class="mi-btn" (click)="triggerFileInput()" title="Attach file" [disabled]="uploading">
      <i class="pi pi-paperclip"></i>
    </button>

    <div class="mi-composer">
      <div
        #highlightLayer
        class="mi-highlight"
        aria-hidden="true"
        [innerHTML]="composerHighlightHtml"
      ></div>
      <textarea
        #textArea
        class="mi-textarea"
        placeholder="Message…"
        rows="1"
        spellcheck="false"
        autocomplete="off"
        [ngModel]="text"
        (keydown)="onKeyDown($event)"
        (input)="onInput($event)"
        (scroll)="syncHighlightScroll()"
      ></textarea>
    </div>

    <button
      class="mi-send-btn"
      (click)="send()"
      [disabled]="uploading || (!text.trim() && !pendingAttachment)"
      [title]="uploading ? 'Uploading attachment...' : 'Send'"
    >
      <i class="pi" [ngClass]="uploading ? 'pi-spin pi-spinner' : 'pi-send'"></i>
    </button>
  </div>

  <input #fileInput type="file" class="mi-file-input" (change)="onFileSelected($event)" />
</div>
